module.exports = __webpack_public_path__ + "img/Monitor.71a26ef8.png";